import { makeAutoObservable } from 'mobx'
// Request
import { InternalConnectedDocumentRequest } from '../requests/InternalConnectedDocumentRequest'

import { clone } from 'lodash'
import { toJS } from 'mobx'
class InternalConnectedDocumentStore {
  //incoming
  internalConnectedDocumentIncomingList = []
  internalConnectedDocumentInTotal = []
  internalConnectedDocumentOutgoingList = []
  internalConnectedDocumentOutTotal = []
  defaultQueryParamsInDoc = {
    page: 0,
    size: 10,
  }
  defaultQueryParamsOutDoc = {
    page: 0,
    size: 10,
  }
  constructor() {
    makeAutoObservable(this)
  }
  clear = () => {
    this.internalConnectedDocumentIncomingList.length = 0
    this.internalConnectedDocumentOutgoingList.length = 0
    this.defaultQueryParamsOutDoc = {
      page: 0,
      size: 10,
    }
    this.defaultQueryParamsInDoc = {
      page: 0,
      size: 10,
    }
  }
  setQueryParamsInDoc = payload => {
    this.defaultQueryParamsInDoc = payload
  }
  setQueryParamsOutDoc = payload => {
    this.defaultQueryParamsOutDoc = payload
  }
  getInternalConnectedDocumentIncomingList = params => {
    return new Promise((resolve, reject) => {
      InternalConnectedDocumentRequest.getInternalConnectedDocumentIncomingList(
        params
      )
        .then(response => {
          this.internalConnectedDocumentIncomingList = [
            ...this.internalConnectedDocumentIncomingList,
            ...toJS(response.data.content),
          ]
          this.internalConnectedDocumentInTotal = response.data.totalElements
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
  getInternalConnectedDocumentIncomingById = docId => {
    return new Promise((resolve, reject) => {
      InternalConnectedDocumentRequest.getInternalConnectedDocumentIncomingById(
        docId
      )
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  //outgoing
  getInternalConnectedDocumentOutgoingList = params => {
    return new Promise((resolve, reject) => {
      InternalConnectedDocumentRequest.getInternalConnectedDocumentOutingList(
        params
      )
        .then(response => {
          this.internalConnectedDocumentOutgoingList = [
            ...this.internalConnectedDocumentOutgoingList,
            ...toJS(response.data.content),
          ]
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
  getInternalConnectedDocumentOutgoingById = docId => {
    return new Promise((resolve, reject) => {
      InternalConnectedDocumentRequest.getInternalConnectedDocumentOutgoingById(
        docId
      )
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  createInternalConnectedDocumentOutgoing = request => {
    return new Promise((resolve, reject) => {
      InternalConnectedDocumentRequest.createInternalConnectedDocumentOutgoing(
        request
      )
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

const internalConnectedDocumentStore = new InternalConnectedDocumentStore()
export default internalConnectedDocumentStore
